import { useMemo } from 'react'

import { deriveHeroCapabilities } from '../utils/deriveHeroCapabilities.js'

/**
 * React hook wrapper — memoizes `deriveHeroCapabilities` over config and settings references.
 *
 * @param {object|null} projectConfig - Configuration object from panel-config.json
 * @param {object|null} panelSettings - Configuration object from panel-settings.json
 * @returns {ReturnType<typeof deriveHeroCapabilities>} Memoized hero capabilities object
 */
export function useHeroCapabilities(projectConfig, panelSettings) {
  return useMemo(
    () => deriveHeroCapabilities(projectConfig, panelSettings),
    [projectConfig, panelSettings],
  )
}
